export const classifyError = (error: any): Record<string, string | number> => {
    const labels: Record<string, string | number> = {};

    const config = error?.config;
    if (config?.url) labels.endpoint = config.url;
    if (config?.method) labels.http_method = config.method;

    const status = error?.response?.status;
    if (status) labels.status_code = status;

    const data = error?.response?.data;
    if (data?.error_type) labels.error_type = data.error_type;
    if (data?.validation_failed_fields) labels.validation_failed_fields = data.validation_failed_fields;

    return labels;
};
